import { CardExpirationFilter } from 'filters/cardExpiration';

export const FormatCardExpiration = angular
    .module('checkout.directives.formatCardExpiration', [
        CardExpirationFilter
    ]).directive('formatCardExpiration', ($filter, $browser) => {
        return {
            require: '?ngModel',
            link: (scope, elem, attrs, ctrl) => {
                if (!ctrl) {
                    return;
                }

                const listener = (key) => {
                    const value = elem.val().replace(/[^\d]+/g, '');
                    if (value.length === 1 && value > 1 && key !== 8) {
                        return elem.val($filter('ccExpiration')(`0${value}`));
                    }
                    return elem.val($filter('ccExpiration')(value, key));
                };

                ctrl.$formatters.unshift(() => {
                    return $filter('ccExpiration')(ctrl.$modelValue || '');
                });

                ctrl.$parsers.unshift((viewValue) => {
                    const plainNumber = viewValue.replace(/[^\d]+/g, '');
                    const MM = plainNumber.slice(0, 2);
                    const year = plainNumber.slice(2, 6);

                    switch (true) {
                        case plainNumber.length === 1 && plainNumber > 1:
                            return `0${plainNumber}`;
                        case year.length >= 2:
                            return `${MM}/${year.length > 2 ? year : `20${year}`}`;
                        default:
                            return MM;
                    }
                });

                elem.on('keydown', (event) => {
                    const key = event.keyCode;
                    if (key === 8) return $browser.defer(() => listener(key));
                    return $browser.defer(listener);
                });
            }
        };
    }).name;



// WEBPACK FOOTER //
// ./src/app/directives/formatCardExpiration.js